import { Box } from '@mui/material'
import { createFileRoute, useParams } from '@tanstack/react-router'
import type { PaginationState, Updater } from '@tanstack/react-table'
import { useState } from 'react'
import { LimitationHistoryDetailModal, useLimitationHistoryColumns } from '@/entities/limitation'
import { ListTable } from '@/entities/list-table'
import type { TaskHistoryEntry } from '@/shared/api/menu-restriction'
import { useTaskHistory } from '@/shared/api/menu-restriction'
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from '@/shared/const'

export const Route = createFileRoute(
  '/_auth/applications/limitations/limitation/$limitationId/history'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { limitationId } = useParams({
    from: '/_auth/applications/limitations/limitation/$limitationId/history',
  })

  const [selectedEntry, setSelectedEntry] = useState<TaskHistoryEntry | null>(null)

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: DEFAULT_PAGE_INDEX,
    pageSize: DEFAULT_PAGE_SIZE,
  })

  const { history, total, isLoading, isError } = useTaskHistory({
    id: limitationId,
    params: {
      'pagination.page': pagination.pageIndex,
      'pagination.pageSize': pagination.pageSize,
    },
  })

  const handlePaginationChange = (updater: Updater<PaginationState>) => {
    const newPagination = typeof updater === 'function' ? updater(pagination) : updater
    setPagination(newPagination)
  }

  const columns = useLimitationHistoryColumns({
    onDetailClick: (entry) => setSelectedEntry(entry),
  })

  return (
    <Box>
      <ListTable
        isLoading={isLoading}
        isError={isError}
        data={history}
        columns={columns}
        pagination={pagination}
        paginationOptions={{
          onPaginationChange: handlePaginationChange,
          rowCount: total,
        }}
      />
      <LimitationHistoryDetailModal
        open={!!selectedEntry}
        onClose={() => setSelectedEntry(null)}
        entry={selectedEntry}
      />
    </Box>
  )
}
